import { Component, input, output } from '@angular/core';
import { TOption } from '../../components/rid-option/rid-option';
import { TKeyValue } from '../../components/rid-syllabic-keyboard/rid-syllabic-keyboard.utils';
import { RidSyllabicKeyboardAssignments } from '../rid-syllabic-keyboard-assignments/rid-syllabic-keyboard-assignments';

@Component({
  selector: 'rid-multisyllabic-keyboard-apply-rule',
  imports: [RidSyllabicKeyboardAssignments],
  templateUrl: './rid-multisyllabic-keyboard-apply-rule.html',
  host: {
    class: 'block',
  },
})
export class RidMultisyllabicKeyboardApplyRule {
  prompts = input.required<{ prompt: TOption; answer: TKeyValue[] }[]>();

  finished = output<void>();
}
